import * as React from "react";
import TextField from "@mui/material/TextField";
import { Autocomplete, useTheme } from "@mui/material";
import { STATUS_SERVICO_OS } from "../../constants";
import { useEffect, useState } from "react";

type Props = {
  codigoStatus: number;
  setStatus: (obj: (typeof STATUS_SERVICO_OS)[0] | null) => void;
  disabled?: boolean;
};

const StatusServicoOSField: React.FC<Props> = (props) => {
  const { codigoStatus, setStatus, disabled } = props;

  const theme = useTheme();

  const [statusSelecionado, setStatusSelecionado] = useState<
    (typeof STATUS_SERVICO_OS)[0] | null
  >(null);
  const xsValue = theme.breakpoints.down("sm") ? 12 : 6;

  useEffect(() => {
    const status = STATUS_SERVICO_OS.find((item) => item.id === codigoStatus);
    if (status) {
      setStatusSelecionado(status);
    }
  }, [codigoStatus]);

  return (
    <div style={{ textAlign: "center" }}>
      <Autocomplete
        id="filter-status-orcamento"
        options={STATUS_SERVICO_OS}
        getOptionLabel={(option) => option.decricao}
        value={statusSelecionado}
        onChange={(event, value) => {
          setStatusSelecionado(value);
          setStatus(value);
        }}
        sx={{ xsValue }}
        renderInput={(params) => (
          <TextField
            {...params}
            disabled={disabled}
            variant={"outlined"}
            label={"Status serviço"}
            placeholder={"Status serviço"}
            multiline={true}
          />
        )}
      />
    </div>
  );
};

export default StatusServicoOSField;
